import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'get-geoLocations-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'todo',
  type: 'get',
  slug: [
    'tasks',
    {
      type: 'payload',
      selector: ['id'],
    },
    'geolocations',
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/get-geoLocations-req.js